export default __webpack_public_path__ + "wrap-blue.svg";